import { useTheme } from "next-themes"
import { Toaster as Sonner, toast as sonnerToast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      // Keep toasts BELOW our modals (z-80) so a 402 modal is never covered.
      offset="80px"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

// Wrapped toast: skip empty/nullish messages so that `toast.error(formatApiError(err))`
// becomes a silent no-op when formatApiError returns "" (e.g. 402 upgrade
// errors — the global UpgradeModalHost handles the UX).
const _skipIfEmpty = (fn) => (message, opts) => {
    if (message === null || message === undefined || message === "") return;
    return fn(message, opts);
};

const toast = Object.assign(
    _skipIfEmpty(sonnerToast),
    sonnerToast,
    {
        error:   _skipIfEmpty(sonnerToast.error),
        success: _skipIfEmpty(sonnerToast.success),
        info:    _skipIfEmpty(sonnerToast.info),
        warning: _skipIfEmpty(sonnerToast.warning),
        message: _skipIfEmpty(sonnerToast.message),
    },
);

export { Toaster, toast }
